module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_03 (1).79b553ab.png";